// extracted by mini-css-extract-plugin
export default {"breadcrumb":"jk-z","breadcrumbItem":"kk-z"};